module.exports = __webpack_public_path__ + "static/media/youtube.a3560e77.svg";